import type { FlagDefinition } from './flag';

const store = new Map<string, FlagDefinition>();

export function registerFlag(definition: FlagDefinition): void {
  const existing = store.get(definition.key);
  if (existing && existing !== definition) {
    throw new Error(`Flag "${definition.key}" is already registered`);
  }
  store.set(definition.key, definition);
}

export function getRegisteredFlags(): ReadonlyArray<FlagDefinition> {
  return Object.freeze([...store.values()]);
}
